import { Pageable } from './../../model/commons.model';
import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';
import { Municipality, Nation, Patient, Province, Region } from 'src/app/model/patient.model';
import { ConfigurationsService } from 'src/app/services/configurations.service';

@Component({
  selector: 'app-patient-details',
  templateUrl: './patient-details.component.html',
  styleUrls: ['./patient-details.component.scss'],
})
export class PatientDetailsComponent implements OnInit {

  @Input() patient: Patient;
  @Input() editing: boolean;
  @Input() confirmLabel: string;
  @Input() cancelLabel: string;

  @Output() cancel = new EventEmitter<any>();
  @Output() perform = new EventEmitter<any>();

  patientForm: FormGroup;
  isNewPatient = true;
  nations: Nation[] = [];
  regions: Region[] = [];
  provinces: Province[] = [];
  municipalities: Municipality[] = [];
  sexualities: string[] = [];
  ethnicities: string[] = [];

  constructor(
    private configurationsService: ConfigurationsService,
    public cdr: ChangeDetectorRef,
    private formBuilder: FormBuilder) {
    this.patientForm = this.formBuilder.group({
      firstName: [''],
      lastName: [''],
      informedConsent: [true],
      enrolledOn: [null],
      dismissedOn: [null],
      demoscopicData: this.formBuilder.group({
        birthDay: [null],
        sex: [''],
        ethnicity: [''],
        nation: [''],
        region: [''],
        province: [''],
        municipality: [''],
      }),
      parentData: this.formBuilder.group({
        firstName: [''],
        lastName: [''],
        cellphone: [''],
        phone: [''],
        email: ['']
      }),
    });
  }

  performAction() {
    const dto: any = {
      patientData: {
      }
    };
    if (this.isNewPatient) {
      dto.isCreation = true;
      dto.patientData.firstName = this.patientForm.get('firstName').value;
      dto.patientData.lastName = this.patientForm.get('lastName').value;
    }
    else {
      dto.isCreation = false;
      dto.patientData.id = this.patient.id;
    }
    if (dto.isCreation || this.patientForm.get('informedConsent').dirty) {
      dto.patientData.informedConsent = this.patientForm.get('informedConsent').value;
    }
    if (dto.isCreation || this.patientForm.get('enrolledOn').dirty) {
      dto.patientData.enrolledOn = this.patientForm.get('enrolledOn').value;
    }
    if (dto.isCreation || this.patientForm.get('dismissedOn').dirty) {
      if (this.patientForm.get('dismissedOn').value !== null && this.patientForm.get('dismissedOn').value !== undefined) {
        dto.patientData.dismissedOn = this.patientForm.get('dismissedOn').value;
      }
    }
    // Demoscopic data
    if (this.patientForm.get('demoscopicData').value !== null &&
        this.patientForm.get('demoscopicData').value !== undefined &&
        ((this.patientForm.get('demoscopicData').get('birthDay').value !== null &&
          this.patientForm.get('demoscopicData').get('birthDay').value !== undefined) ||
          (this.patientForm.get('demoscopicData').get('sex').value !== null &&
          this.patientForm.get('demoscopicData').get('sex').value !== undefined) ||
          (this.patientForm.get('demoscopicData').get('ethnicity').value !== null &&
          this.patientForm.get('demoscopicData').get('ethnicity').value !== undefined) ||
          (this.patientForm.get('demoscopicData').get('municipality').value !== null &&
          this.patientForm.get('demoscopicData').get('municipality').value !== undefined))) {
        dto.demoscopicData = {};
        if (this.patientForm.get('demoscopicData').get('birthDay').value !== null &&
            this.patientForm.get('demoscopicData').get('birthDay').value !== undefined) {
          dto.demoscopicData.birthDay = this.patientForm.get('demoscopicData').get('birthDay').value;
        }
        if (this.patientForm.get('demoscopicData').get('sex').value !== null &&
            this.patientForm.get('demoscopicData').get('sex').value !== undefined) {
          dto.demoscopicData.sex = this.patientForm.get('demoscopicData').get('sex').value;
        }
        if (this.patientForm.get('demoscopicData').get('ethnicity').value !== null &&
            this.patientForm.get('demoscopicData').get('ethnicity').value !== undefined) {
          dto.demoscopicData.ethnicity = this.patientForm.get('demoscopicData').get('ethnicity').value;
        }
        if (this.patientForm.get('demoscopicData').get('municipality').value !== null &&
            this.patientForm.get('demoscopicData').get('municipality').value !== undefined) {
          dto.demoscopicData.municipality = this.patientForm.get('demoscopicData').get('municipality').value;
        }
    }
    else {
      dto.demoscopicData = null;
    }
    // parent data
    if (this.patientForm.get('parentData').value !== null &&
        this.patientForm.get('parentData').value !== undefined &&
        ((this.patientForm.get('parentData').get('firstName').value !== null &&
          this.patientForm.get('parentData').get('firstName').value !== undefined) ||
          (this.patientForm.get('parentData').get('lastName').value !== null &&
          this.patientForm.get('parentData').get('lastName').value !== undefined) ||
          (this.patientForm.get('parentData').get('cellphone').value !== null &&
          this.patientForm.get('parentData').get('cellphone').value !== undefined) ||
          (this.patientForm.get('parentData').get('phone').value !== null &&
          this.patientForm.get('parentData').get('phone').value !== undefined) ||
          (this.patientForm.get('parentData').get('email').value !== null &&
          this.patientForm.get('parentData').get('email').value !== undefined))) {
        dto.parentData = {};
        if (this.patientForm.get('parentData').get('firstName').value !== null &&
            this.patientForm.get('parentData').get('firstName').value !== undefined) {
          dto.parentData.firstName = this.patientForm.get('parentData').get('firstName').value;
        }
        if (this.patientForm.get('parentData').get('lastName').value !== null &&
            this.patientForm.get('parentData').get('lastName').value !== undefined) {
          dto.parentData.lastName = this.patientForm.get('parentData').get('lastName').value;
        }
        if (this.patientForm.get('parentData').get('cellphone').value !== null &&
            this.patientForm.get('parentData').get('cellphone').value !== undefined) {
          dto.parentData.cellphone = this.patientForm.get('parentData').get('cellphone').value;
        }
        if (this.patientForm.get('parentData').get('phone').value !== null &&
            this.patientForm.get('parentData').get('phone').value !== undefined) {
          dto.parentData.phone = this.patientForm.get('parentData').get('phone').value;
        }
        if (this.patientForm.get('parentData').get('email').value !== null &&
            this.patientForm.get('parentData').get('email').value !== undefined) {
          dto.parentData.email = this.patientForm.get('parentData').get('email').value;
        }
    }
    else {
      dto.parentData = null;
    }
    this.perform.emit(dto);
  }

  ngOnInit() {
    this.checkIsNewPatient();
    this.loadConfiguredLocations();
  }

  ionViewWillEnter(){

  }

  checkIsNewPatient() {
    this.isNewPatient =
    (this.patient === null || this.patient === undefined) ||
    (this.patient !== null && this.patient !== undefined && (this.patient.id === null || this.patient.id === undefined));
  }

  private hasNation(): boolean {
    return (
      this.patient !== null && this.patient !== undefined &&
      this.patient.demoscopicData !== null && this.patient.demoscopicData !== undefined &&
      this.patient.demoscopicData.nation !== null && this.patient.demoscopicData.nation !== undefined);
  }

  private hasRegion(): boolean {
    return (
      this.patient !== null && this.patient !== undefined &&
      this.patient.demoscopicData !== null && this.patient.demoscopicData !== undefined &&
      this.patient.demoscopicData.region !== null && this.patient.demoscopicData.region !== undefined);
  }

  private hasProvince(): boolean {
    return (
      this.patient !== null && this.patient !== undefined &&
      this.patient.demoscopicData !== null && this.patient.demoscopicData !== undefined &&
      this.patient.demoscopicData.province !== null && this.patient.demoscopicData.province !== undefined);
  }

  private hasMunicipality(): boolean {
    return (
      this.patient !== null && this.patient !== undefined &&
      this.patient.demoscopicData !== null && this.patient.demoscopicData !== undefined &&
      this.patient.demoscopicData.municipality !== null && this.patient.demoscopicData.municipality !== undefined);
  }

  reloadRegions(){
    this.configurationsService.getRegions(
      this.patientForm.get('demoscopicData').get('nation').value)
      .subscribe((res) => {
        this.regions = res;
        this.provinces = [];
        this.municipalities = [];
    });
  }

  reloadProvinces(){
    this.configurationsService.getProvinces(
      this.patientForm.get('demoscopicData').get('region').value)
      .subscribe((res) => {
        this.provinces = res;
        this.municipalities = [];
    });
  }
  reloadMunicipalities(){
    this.configurationsService.getMunicipalities(
      this.patientForm.get('demoscopicData').get('province').value)
      .subscribe((res) => {
        this.municipalities = res;
    });
  }

  loadConfiguredLocations() {
    const locationsToLoad: Promise<any>[] = [];
    locationsToLoad.push(this.configurationsService.getEthnicities().toPromise());
    locationsToLoad.push(this.configurationsService.getSexualities().toPromise());
    locationsToLoad.push(this.configurationsService.getNations().toPromise());
    if (this.hasNation()) {
      locationsToLoad.push(this.configurationsService.getRegions(this.patient.demoscopicData.nation.id)
        .toPromise());
      if (this.hasRegion()) {
        locationsToLoad.push(this.configurationsService.getProvinces(this.patient.demoscopicData.region.id)
          .toPromise());
        if (this.hasProvince()) {
          locationsToLoad.push(this.configurationsService.getMunicipalities(this.patient.demoscopicData.province.id)
            .toPromise());
        }
      }
    }
    const locationsToLoadPromise = Promise.all(locationsToLoad);
    locationsToLoadPromise.then((data) => {
      if (data.length >= 1) {
        this.ethnicities = data[0];
      }
      if (data.length >= 2) {
        this.sexualities = data[1];
      }
      if (data.length >= 3) {
        this.nations = data[2];
      }
      if (data.length >= 4) {
        this.regions = data[3];
      }
      if (data.length >= 5) {
        this.provinces = data[4];
      }
      if (data.length >= 6) {
        this.municipalities = data[5];
      }
      this.cdr.detectChanges();
    }).then(() => {
      this.patientForm.get('enrolledOn').setValidators(Validators.required);
      if (this.isNewPatient) {
        this.patientForm.get('firstName').setValidators(Validators.compose([
          Validators.required,
          Validators.minLength(4),
          Validators.maxLength(128)]));
        this.patientForm.get('lastName').setValidators(Validators.compose([
          Validators.required,
          Validators.minLength(4),
          Validators.maxLength(128)]));
        this.patientForm.get('enrolledOn').setValue((new Date()).toISOString());
      }
      else {
        this.patientForm.get('firstName').setValue(this.patient.firstName);
        this.patientForm.get('lastName').setValue(this.patient.lastName);
        this.patientForm.get('informedConsent').setValue(this.patient.informedConsent);
        this.patientForm.get('enrolledOn').setValue((new Date(this.patient.enrolledOn)).toISOString());
        if (this.patient.dismissedOn !== null && this.patient.dismissedOn !== undefined) {
          this.patientForm.get('dismissedOn').setValue((new Date(this.patient.dismissedOn)).toISOString());
        }
        if (this.patient.demoscopicData !== null && this.patient.demoscopicData !== undefined) {
          if (this.patient.demoscopicData.birthDay !== null && this.patient.demoscopicData.birthDay !== undefined) {
            this.patientForm.get('demoscopicData').get('birthDay').setValue((new Date(this.patient.demoscopicData.birthDay)).toISOString());
          }
          this.patientForm.get('demoscopicData').get('sex').setValue(this.patient.demoscopicData.sex);
          this.patientForm.get('demoscopicData').get('ethnicity').setValue(this.patient.demoscopicData.ethnicity);
          if (this.patient.demoscopicData.nation !== null && this.patient.demoscopicData.nation !== undefined) {
            this.patientForm.get('demoscopicData').get('nation').setValue(this.patient.demoscopicData.nation.id);
          }
          if (this.patient.demoscopicData.region !== null && this.patient.demoscopicData.region !== undefined) {
            this.patientForm.get('demoscopicData').get('region').setValue(this.patient.demoscopicData.region.id);
          }
          if (this.patient.demoscopicData.province !== null && this.patient.demoscopicData.province !== undefined) {
            this.patientForm.get('demoscopicData').get('province').setValue(this.patient.demoscopicData.province.id);
          }
          if (this.patient.demoscopicData.municipality !== null && this.patient.demoscopicData.municipality !== undefined) {
            this.patientForm.get('demoscopicData').get('municipality').setValue(this.patient.demoscopicData.municipality.id);
          }
        }
        if (this.patient.parentData !== null && this.patient.parentData !== undefined) {
          this.patientForm.get('parentData').get('firstName').setValue(this.patient.parentData.parentFirstName);
          this.patientForm.get('parentData').get('lastName').setValue(this.patient.parentData.parentLastName);
          this.patientForm.get('parentData').get('cellphone').setValue(this.patient.parentData.parentCellphone);
          this.patientForm.get('parentData').get('phone').setValue(this.patient.parentData.parentPhone);
          this.patientForm.get('parentData').get('email').setValue(this.patient.parentData.parentEmail);
        }
      }
    });
  }

  cancelAction() {
    this.cancel.emit();
  }
}
